import type { ThunkDispatch, UnknownAction } from "@reduxjs/toolkit";
import { useDispatch, useSelector, type TypedUseSelectorHook } from "react-redux";
import type { UsersState } from "./users.slice";

/** See @vv/teams-frontend/src/state/hooks.ts for why this is deliberately
 * local/narrow rather than importing @vv/state's RootState. */
interface UsersModuleState {
  users: UsersState;
}

type UsersModuleDispatch = ThunkDispatch<UsersModuleState, unknown, UnknownAction>;

export const useUsersDispatch = () => useDispatch<UsersModuleDispatch>();
export const useUsersSelector: TypedUseSelectorHook<UsersModuleState> = useSelector;
